export default __webpack_public_path__ + "static/media/generalInsurance_main.6032c3ff.jpg";